import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { globalSettings } from 'src/global-settings';

@Component({
  selector: 'horizon-notification-list',
  templateUrl: './notification-list.component.html',
  styleUrls: ['./notification-list.component.scss'],
})
export class NotificationListComponent {
  @Input() title!: string;
  @Input() notifications!: object[];

  globalSettings = globalSettings;

  constructor(public readonly translate: TranslateService) {}
}
